import { InvitationDto } from 'woofwoof-api';
import { translateKey } from 'src/locales/translate';


export const mapInvitationStatusEnumToString = (
  status: InvitationDto['status'],
): string => {
  const statusTranslations: Record<string, string> = {
    SENT: translateKey("hardcoded.wyslane"),
    ACCEPTED: 'Zaakceptowane',
    REJECTED: 'Odrzucone',
    EXPIRED: translateKey("hardcoded.wygasle"),
  };

  return statusTranslations[status] || status;
};
